var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"journey-metadata"},[(_vm.duration)?_c('span',{staticClass:"time-to-complete"},[_vm._v("\n    "+_vm._s(_vm.$t('message.recommended-time-to-complete'))+": "+_vm._s(_vm.monthText)+" "+_vm._s(_vm.weekText)+"\n  ")]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }